"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.link.js");
require("core-js/modules/es6.regexp.replace.js");
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactButtonShort = _interopRequireDefault(require("@nerdwallet/react-button-short"));
var _Lock = _interopRequireDefault(require("@nerdwallet/react-icon/gizmo/Lock"));
var _Box = require("@nerdwallet/currency/components/Box");
var _Link = require("@nerdwallet/currency/components/Link");
var _Text = require("@nerdwallet/currency/components/Text");
var _classes = _interopRequireDefault(require("@nerdwallet/base-styles/classes"));
var _applyNowLink = _interopRequireDefault(require("./apply-now-link"));
var _applyNowModule = _interopRequireDefault(require("./apply-now.module.css"));
/* eslint-disable camelcase */

function getAnnotationText(_ref) {
  var issuer = _ref.issuer,
    payPerCall = _ref.payPerCall;
  if (!issuer) return null;
  var wordForWebsite = issuer && issuer.toLowerCase() === 'citibank' ? 'application' : 'website';
  var phoneText = payPerCall ? ', or call ' : '';
  return "on ".concat(issuer).concat(/s$/.test(issuer) ? "'" : "'s", " ").concat(wordForWebsite).concat(phoneText);
}
var ApplyNow = function ApplyNow(_ref2) {
  var additionalAttributes = _ref2.additionalAttributes,
    annotationText = _ref2.annotationText,
    className = _ref2.className,
    _ref2$component = _ref2.component,
    component = _ref2$component === void 0 ? _reactButtonShort.default : _ref2$component,
    _ref2$disableAnnotati = _ref2.disableAnnotation,
    disableAnnotation = _ref2$disableAnnotati === void 0 ? false : _ref2$disableAnnotati,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    _ref2$finishType = _ref2.finishType,
    finishType = _ref2$finishType === void 0 ? 'external_application' : _ref2$finishType,
    _ref2$hasPrequalified = _ref2.hasPrequalified,
    hasPrequalified = _ref2$hasPrequalified === void 0 ? false : _ref2$hasPrequalified,
    icon = _ref2.icon,
    id = _ref2.id,
    _ref2$isCC = _ref2.isCC,
    isCC = _ref2$isCC === void 0 ? false : _ref2$isCC,
    _ref2$isNoImpactToCre = _ref2.isNoImpactToCredit,
    isNoImpactToCredit = _ref2$isNoImpactToCre === void 0 ? false : _ref2$isNoImpactToCre,
    issuer = _ref2.issuer,
    _ref2$issuerNameApply = _ref2.issuerNameApply,
    issuerNameApply = _ref2$issuerNameApply === void 0 ? false : _ref2$issuerNameApply,
    link = _ref2.link,
    _ref2$linkType = _ref2.linkType,
    linkType = _ref2$linkType === void 0 ? 'APPLY_NOW_BUTTON' : _ref2$linkType,
    monetizable = _ref2.monetizable,
    _ref2$newWindow = _ref2.newWindow,
    newWindow = _ref2$newWindow === void 0 ? true : _ref2$newWindow,
    _ref2$onClick = _ref2.onClick,
    onClick = _ref2$onClick === void 0 ? function () {} : _ref2$onClick,
    pageNumber = _ref2.pageNumber,
    pay_per_call = _ref2.pay_per_call,
    prequalId = _ref2.prequalId,
    _ref2$primary = _ref2.primary,
    primary = _ref2$primary === void 0 ? true : _ref2$primary,
    productDisplayDriver = _ref2.productDisplayDriver,
    productId = _ref2.productId,
    productPosition = _ref2.productPosition,
    referringUrl = _ref2.referringUrl,
    rel = _ref2.rel,
    _ref2$secondary = _ref2.secondary,
    secondary = _ref2$secondary === void 0 ? false : _ref2$secondary,
    sectionName = _ref2.sectionName,
    sectionPosition = _ref2.sectionPosition,
    _ref2$showIcon = _ref2.showIcon,
    showIcon = _ref2$showIcon === void 0 ? true : _ref2$showIcon,
    _ref2$tertiary = _ref2.tertiary,
    tertiary = _ref2$tertiary === void 0 ? false : _ref2$tertiary,
    _ref2$text = _ref2.text,
    text = _ref2$text === void 0 ? '' : _ref2$text,
    _ref2$textClassName = _ref2.textClassName,
    textClassName = _ref2$textClassName === void 0 ? '' : _ref2$textClassName;
  var getPhoneCTA = function getPhoneCTA() {
    if (!pay_per_call) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement(_Link.Link, {
      className: (0, _classes.default)('nowrap'),
      href: "tel:".concat(pay_per_call.replace(/\D/g, ''))
    }, pay_per_call);
  };
  var getAnnotation = function getAnnotation() {
    if (disableAnnotation) {
      return null;
    }
    var annotationContent = annotationText || getAnnotationText({
      issuer: issuer,
      payPerCall: pay_per_call
    });
    var phoneCTA = getPhoneCTA();
    var annotationClassName = (0, _classnames.default)(['annotation', (0, _classes.default)(['margin-top-1'])]);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: annotationClassName
    }, /*#__PURE__*/_react.default.createElement(_Text.Text, {
      tone: "light",
      size: "small",
      component: "p",
      align: "center"
    }, annotationContent, phoneCTA));
  };
  var applyText = function applyText() {
    var content = 'Apply Now';
    if (text) {
      content = text;
    } else if (issuerNameApply) {
      content = "Apply on ".concat(issuer);
    }
    return /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)([(0, _classes.default)('margin-right-1'), textClassName])
    }, content);
  };
  var applySubtext = function applySubtext() {
    if (!isNoImpactToCredit) return null;
    return /*#__PURE__*/_react.default.createElement(_Box.Box, {
      marginTop: 1
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)([(0, _classes.default)('margin-right-1'), _applyNowModule.default.subtextClassName])
    }, "Won't affect your credit score"));
  };
  var containerClassName = (0, _classnames.default)([className, 'apply-now']);
  var buttonClassName = (0, _classnames.default)([(0, _classes.default)('width-100'), (0, _classes.default)('text-align-center')]);
  var iconElement = showIcon ? icon || /*#__PURE__*/_react.default.createElement(_Lock.default, {
    textAligned: true,
    className: _applyNowModule.default.icon
  }) : null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: containerClassName
  }, /*#__PURE__*/_react.default.createElement(_applyNowLink.default, {
    additionalAttributes: additionalAttributes,
    annotationText: annotationText,
    component: component,
    disableAnnotation: disableAnnotation,
    disabled: disabled,
    finishType: finishType,
    hasPrequalified: hasPrequalified,
    id: id,
    isCC: isCC,
    issuer: issuer,
    issuerNameApply: issuerNameApply,
    link: link,
    linkType: linkType,
    monetizable: monetizable,
    newWindow: newWindow,
    onClick: onClick,
    pageNumber: pageNumber,
    pay_per_call: pay_per_call,
    prequalId: prequalId,
    primary: primary,
    productDisplayDriver: productDisplayDriver,
    productId: productId,
    productPosition: productPosition,
    referringUrl: referringUrl,
    rel: rel,
    role: "link",
    secondary: secondary,
    sectionName: sectionName,
    sectionPosition: sectionPosition,
    tertiary: tertiary,
    className: buttonClassName
  }, applyText(), iconElement, applySubtext()), getAnnotation());
};
var _default = ApplyNow;
exports.default = _default;